import { Component, HostBinding, OnInit, inject } from '@angular/core'
import { locale } from 'devextreme/localization'
import { ScreenService } from './shared/services'
import { NotificationService } from './shared/services/notification.service'
import { environment } from 'src/environments/environment'
import dayjs from 'dayjs'
import { DAY_JS_CONFIG } from 'src/config/global-config'
import { REDIRECT_URL_KEY } from './types/session-state'
import { SideNavOuterToolbarComponent } from './layouts/side-nav-outer-toolbar/side-nav-outer-toolbar.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [SideNavOuterToolbarComponent, RouterOutlet]
})
export class AppComponent implements OnInit {
  private screen = inject(ScreenService);
  private notiService = inject(NotificationService);

  isIframe = false

  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes)
      .filter((cl) => this.screen.sizes[cl])
      .join(' ')
  }

  constructor() {
    locale('AU')
    dayjs.locale('en-au', DAY_JS_CONFIG)
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener

    // Store the path to allow redirection after login
    const path = window.location.pathname
    if (/^\/(dashboard\/)?\d+/.test(path)) {
      sessionStorage.setItem(REDIRECT_URL_KEY, path + window.location.search)
    }

    const browser = window.navigator.userAgent.toLowerCase()
    if (browser.indexOf('firefox') > 0 && !environment.local) {
      this.notiService.showWarning(
        'While this app functions on Firefox, Chrome & Edge are the officially supported browsers.' +
          '<br><br> If you encounter any issues please test on these browsers before raising it with support.',
        'Warning',
        { timeOut: 0, enableHtml: true, positionClass: 'toast-bottom-full-width' }
      )
    }
  }
}
